import { Box, Grid2 as Grid } from '@mui/material';
import { Panel } from 'reactflow';
import { color, EL_COLORS } from '@/colors';
import { WorkflowEditorMode } from '@/enums/workflow-editor-mode.enum';
import { FlexCenVer } from '@/UI/styles';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { FF_WORKFLOW_APP_BUILDER_MODE } from '@/consts/featureFlags';
import { CreditsInfo } from '../FlowComponents/CreditsInfo/CreditsInfo';
import { WorkflowRightToolbar } from '../FlowComponents/WorkflowRightToolbar/WorkflowRightToolbar';
import { useWorkflowEditorMode } from '../FlowComponents/WorkflowRightToolbar/workflowEditorMode.store';
import { PANEL_WIDTH } from '../consts/ui';
import { WorkflowPropertiesPanel, hasDisplayableWorkflowProperties } from './WorkflowPropertiesPanel';
import { AppBuilderPanel } from './AppBuilderPanel';
import type { Node } from '@/types/node';

interface WorkflowRightPanelProps {
  selectedNodes: Node[];
}

function WorkflowRightPanelBody({
  workflowEditorMode,
  selectedNodes,
}: {
  workflowEditorMode: WorkflowEditorMode;
  selectedNodes: Node[];
}) {
  switch (workflowEditorMode) {
    case WorkflowEditorMode.AppBuilder:
      return <AppBuilderPanel />;
    case WorkflowEditorMode.EditWorkflow:
      return <WorkflowPropertiesPanel selectedNodes={selectedNodes} />;
  }
}

export function WorkflowRightPanel({ selectedNodes }: WorkflowRightPanelProps) {
  const { workflowEditorMode } = useWorkflowEditorMode();
  const { value: isWorkflowAppBuilderEnabled } = useFeatureFlag(FF_WORKFLOW_APP_BUILDER_MODE);

  const isPanelOpen =
    workflowEditorMode === WorkflowEditorMode.AppBuilder || hasDisplayableWorkflowProperties(selectedNodes);

  return (
    <Panel
      position="top-right"
      style={{
        height: '100%',
        width: `${PANEL_WIDTH}px`,
        top: '0px',
        right: '0px',
        margin: 0,
      }}
      className={isPanelOpen ? 'slide-right-enter' : 'slide-right-exit'}
    >
      <Box
        sx={{
          height: '100%',
          overflowY: 'auto',
          backgroundColor: color.Black92,
          borderLeft: `1px solid ${EL_COLORS.BoxBorder}`,
        }}
      >
        {isPanelOpen && (
          <Grid container direction="column" sx={{ height: '100%' }}>
            <Grid size="auto">
              <FlexCenVer
                data-testid="properties-title"
                sx={{
                  borderBottom: `1px solid ${EL_COLORS.BoxBorder}`,
                  pl: 1.5,
                  pr: 2,
                  height: '84px',
                }}
              >
                {isWorkflowAppBuilderEnabled ? (
                  <WorkflowRightToolbar isPaperBg={false} />
                ) : (
                  <CreditsInfo isPaperBg={false} />
                )}
              </FlexCenVer>
            </Grid>

            <WorkflowRightPanelBody workflowEditorMode={workflowEditorMode} selectedNodes={selectedNodes} />
          </Grid>
        )}
      </Box>
    </Panel>
  );
}
